export function escapeHtml(string)
{
    let entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };

    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
        return entityMap[s];
    });
}

export function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

export function is(obj, path, otherwise = null, hasMode = false)
{
    var keys = Array.isArray(path) ? path : path.split('.')

    let has = undefined

    for( var i = 0; i < keys.length; i++ )
    {
        var key = keys[i]

        if( ! obj || ( ! isArray(obj) && ! isObject(obj) ) || ! obj.hasOwnProperty(key) )
        {
            obj = otherwise

            if( hasMode ) {
                has = false
            }

            break
        }

        obj = obj[key]
    }

    if( hasMode )
    {
        return has !== undefined ? has : true
    }

    return obj
}

export function hasDeep(obj, path)
{
    if( ! path) return false
    return is(obj, path, null, true)
}

export function setDeep(obj, path, value)
{
    var keys = Array.isArray(path) ? path : path.split('.')

    for (var i = 0; i < keys.length - 1; i++)
    {
        var key = keys[i]

        if ( ! obj.hasOwnProperty(key) ) obj[key] = {}

        obj = obj[key]
    }

    obj[keys[i]] = value

    return true
}

export function substringIndex(input, delimiter, index) {
    let arr = input.split(delimiter)
    arr.splice(index, arr.length - index)
    return arr.join(delimiter)
}

export function isValidJSON(text) {
    try {
        fromJson(text)
        return true
    } catch (e) {
        return false
    }
}

export function arrayFromObject(object) {
    if( ! isObject(object) ) {
        console.error('[arrayFromObject]: Value is not an object!')
    }
    return Object.keys(object).map( key => object[key] )
}

export function deleteFromArray(value, array) {
    let index = array.indexOf(value)
    if (index > -1) {
        array.splice(index, 1)
    }
    return array
}

export function arrayUniquePush(array, value) {
    if( ! isArray(array) ) {
        console.error('[arrayUniquePush]: Value is not an array!')
    }

    if( array.indexOf(value) === -1 ) {
        array.push(value)
    }

    return array
}

export function toJson(target)
{
    return JSON.stringify(target)
}

export function fromJson(target)
{
    return JSON.parse(target)
}

export function cloneObject(target)
{
    return fromJson(toJson(target)) // deep clone
}

export function getObjectLength(object) {
    return Object.keys(object).length
}

export function time()
{
    return Math.round(new Date().getTime()/1000)
}

export function truncate(str, num, end = '...') {
    if (String(str).length > num) {
        return String(str).slice(0, num) + end
    }
    else {
        return str
    }
}

export function nl2br(value)
{
    return value.replace(/(?:\r\n|\r|\n)/g, '<br>')
}

export function capitalize(value) {
    if (!value && value !== 0) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
}

export function isArray(target)
{
    return Array.isArray(target)
}

export function isObject(target)
{
    return typeOf(target) === 'object'
}

/**
 * Searches an array for a specific value
 *
 * @param needle Search value
 * @param haystack Array pool
 * @param strict Whether to compare also by type ===

 * @returns {*} Boolean
 */
export function inArray(needle, haystack, strict = false)
{
    if( strict )
        return haystack.indexOf(needle) !== -1

    return !! haystack.filter(option => option == needle).length
}

export function isArrayWithObjects(item)
{
    if( ! Array.isArray(item))
        return false

    if( item.length === 0 )
        return false

    return typeOf(item.slice(0).shift()) === 'object'
}

export function isNullOrUndefined(value) {
    return value === null || value === undefined
}

export function isEmpty(val)
{
    return (
        null === val ||
        "" === val ||
        undefined === val ||
        (
            typeOf(val) === "object" && Object.keys(val).length === 0 ||
            val.length === 0
        )
    )
}

export function trimSlashes(str)
{
    if(str === undefined || str === null)
        return str

    return new String(str).trim().replace(/\/$/, "")
}

export function d(...data)
{
    console.log.apply(null, data)
}

export function ww(...data) {
    data.forEach( item => w(JSON.stringify(item, null, 2)) )
}

export function w(...data)
{
    console.warn.apply(null, data)
}

export function typeOf(obj)
{
    return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase()
}

export function urlencode (str)
{
    str = (str + '').toString()

    return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
        .replace(/%20/g, '+')
}

/**
 * var myPromise = toSmartPromise(new Promise(function(resolve,reject){
 *     setTimeout(function(){
 *         resolve("Yeah !")
 *     },10000)
 * }))
 *
 * console.log("Initial fulfilled:", myPromise.isFulfilled())
 * console.log("Initial rejected:", myPromise.isRejected())
 * console.log("Initial pending:", myPromise.isPending())
 *
 * myPromise.then(function(data){
 *     console.log(data) // "Yeah !"
 *     console.log("Final fulfilled:", myPromise.isFulfilled())
 *     console.log("Final rejected:", myPromise.isRejected())
 *     console.log("Final pending:", myPromise.isPending())
 * })
 */
export function toSmartPromise(promise) {
    // Don't modify any promise that has been already modified.
    if (promise.isResolved) return promise

    // Set initial state
    var isPending = true
    var isRejected = false
    var isResolved = false

    // Observe the promise, saving the fulfillment in a closure scope.
    var result = promise.then(
        value => {
            isResolved = true
            isPending = false
            return value
        },
        error => {
            isRejected = true
            isPending = false
            throw error
        }
    )

    result.isResolved = () => isResolved
    result.isPending = () => isPending
    result.isRejected = () => isRejected

    return result
}

export function http_build_query(formdata, numericPrefix, argSeparator)
{
    // eslint-disable-line camelcase
    var value
    var key
    var tmp = []
    var _httpBuildQueryHelper = function (key, val, argSeparator) {
        var k
        var tmp = []
        if (val === true) {
            val = '1'
        } else if (val === false) {
            val = '0'
        }
        if (val !== null) {
            if (typeof val === 'object') {
                for (k in val) {
                    if (val[k] !== null) {
                        tmp.push(_httpBuildQueryHelper(key + '[' + k + ']', val[k], argSeparator))
                    }
                }
                return tmp.join(argSeparator)
            } else if (typeof val !== 'function') {
                return urlencode(key) + '=' + urlencode(val)
            } else {
                throw new Error('There was an error processing for http_build_query().')
            }
        } else {
            return ''
        }
    }
    if (!argSeparator) {
        argSeparator = '&'
    }
    for (key in formdata) {
        value = formdata[key]
        if (numericPrefix && !isNaN(key)) {
            key = String(numericPrefix) + key
        }
        var query = _httpBuildQueryHelper(key, value, argSeparator)
        if (query !== '') {
            tmp.push(query)
        }
    }
    return tmp.join(argSeparator)
}

export function isValidByEncoding(string, encoding, allowedCharactersArray) {
    allowedCharactersArray = allowedCharactersArray || []; // option to specify allowed characters
    encoding = encoding == 0 ? 'GSM-7' : encoding == 3 ? 'Latin-1' : 'UCS2';

    if (!string || encoding == 'UCS2') {
        return true;
    }
    // https://en.wikipedia.org/wiki/GSM_03.38 - GSM 7-bit default alphabet and extension table of 3GPP TS 23.038 / GSM 03.38
    let gsm7Characters = `
            ! " # $ % & ' ( ) * + , - . / 0 1 2 3 4 5 6 7 8 9 : ; < = > ? @
            A B C D E F G H I J K L M N O P Q R S T U V W X Y Z a b c d e f g h i j k l m n o p q r s t u v w x y z
            Ä Ö Ñ Ü § ¿ ä ö ñ ü à | ^ € { } [ ~ ] ¤ ¡ £ ¥ è é ù ì ò Ç Ø ø Å å Δ _ Φ Γ Λ Ω Π Ψ Σ Θ Ξ Æ æ ß É \\
        `;
    // https://cs.stanford.edu/people/miles/iso8859.html#ISO
    let latin1Characters = `
            ! " # $ % & ' ( ) * + , - . / 0 1 2 3 4 5 6 7 8 9 : ; < = > ? @
            A B C D E F G H I J K L M N O P Q R S T U V W X Y Z a b c d e f g h i j k l m n o p q r s t u v w x y z
            À Á Â Ã Ä Å Æ Ç È É Ê Ë Ì Í Î Ï Ð Ñ Ò Ó Ô Õ Ö × Ø Ù Ú Û Ü Ý Þ ß à á â ã ä å æ ç è é ê ë ì í î ï ð ñ ò ó ô õ ö ÷ ø ù ú û ü ý þ ÿ
            [ \\ ] ^ _ \` { | } ~ ¡ ¢ £ ¤ ¥ ¦ § ¨ © ª « ¬ ­ ® ¯ ° ± ² ³ ´ µ ¶ · ¸ ¹ º » ¼ ½ ¾ ¿
        `;

    let unsupportedCharactersFound = '';
    // GSM-7 allowed control char codes
    let invisibleGSM7CharCodes = [10, 12, 13, 27, 32]; // LF, FF, CR ,ESC, SP

    for (let i = 0; i < string.length; i++)
    {
        let char = string[i];
        let charCode = string.charCodeAt(i);

        if (allowedCharactersArray.length && allowedCharactersArray.includes(char)) {
            continue;
        }

        // Latin-1 allowed control char codes + non-breaking space(charCode 160)
        let isInvisibleLatin1Char = charCode < 32 || (charCode > 127 && charCode <= 160);

        if (encoding == 'GSM-7' && gsm7Characters.indexOf(char) === -1 && !invisibleGSM7CharCodes.includes(charCode)) {
            unsupportedCharactersFound += char + ' ';

            if (charCode == 160) {
                unsupportedCharactersFound += (';nbsp(non-breaking space) ');
            }
        } else if (encoding == 'Latin-1' && (!isInvisibleLatin1Char && latin1Characters.indexOf(char) === -1)) {
            unsupportedCharactersFound += char + ' ';
        }
    }

    if (unsupportedCharactersFound) {
        // remove duplicates
        unsupportedCharactersFound = unsupportedCharactersFound
            .split(' ')
            .filter(function(item, pos, self) {
                return self.indexOf(item) == pos;
            })
            .join(' ');
        return {
            errorMessage: `Unsupported ${encoding} characters have been found: ${unsupportedCharactersFound}`,
            supportedCharacters: encoding == 'GSM-7' ? gsm7Characters : latin1Characters,
        }
    }
    return true;
}
